// extracted by mini-css-extract-plugin
export var drawerPaper = "_1f-0";
export var itemCard = "_1f-1";
export var itemImage = "_1f-2";